import {
  Button,
  Modal,
  Form,
  Input,
  InputNumber,
  Flex,
  Typography,
  message,
  Radio,
  Select,
} from "antd";
import React, { forwardRef, useState, useImperativeHandle } from "react";
import { EditOutlined } from "@ant-design/icons";
import http from "@/utils/http";
import api from "@/utils/api";

const AddModal = forwardRef((props, ref) => {
  const { onSuccess } = props;
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [parentlist, setParentlist] = useState([]);
  // 单选：Yes=1, No=0
  const typeOptions = [
    // { label: "SICK", value: 'SICK' },
    // { label: "VACATION", value: 'VACATION' },
    { label: "RENT_CREDIT", value: 'RENT_CREDIT' },
  ];

    const stateOptions = [
    { label: "Enable", value: '1' },
    { label: "Disable", value: '0' },
  ];


  const loadParentlist = async () => {
    try {
      const response = await http.get(api.getGlTransRulesList);
      const data = (response.data || []).map((item) => ({
        value: item.id,
        label: item.name,
      }));
      setParentlist(data);
    } catch (err) {
      console.error("Failed :", err);
    }
  };

  useImperativeHandle(ref, () => ({
    setModelAdd: async (parentId = null) => {
      form.resetFields();
      form.setFieldsValue();
      setVisible(true);
      await Promise.all([loadParentlist()]);
    },
  }));

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const queryParams = {
       ...values,
       allowanceType:"RENT_CREDIT",
      };
      const response = await http.post(api.getEmployeesTimeAdd, queryParams);
      if (response?.code === "1") {
        message.success("Added successfully.");

        setVisible(false);
        form.resetFields();
        onSuccess && onSuccess();
      } else {
        message.error(response?.msg);
      }
    } catch (err) {
      console.error(err);
      message.error("Request failed, please try again");
    } finally {
      setLoading(false);
    }
  };

  const usdFormatter = (value) => {
    if (value === undefined || value === null || value === "") return "";
    return `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const usdParser = (value) => value?.replace(/\$\s?|(,*)/g, "");

  return (
    <Modal
      title={
        <Flex justify="flex-start" align="flex-start" className="model_title">
          <EditOutlined className="model_title_mr10" />
          <Typography.Title level={4} className="mg">
            ADD EMPLOYEES TIMEALLOWANCE
          </Typography.Title>
        </Flex>
      }
      width="60%"
      open={visible}
      onCancel={() => {
        setVisible(false);
        form.resetFields();
      }}
      maskClosable={false}
      footer={
               <div style={{ display: "flex", justifyContent: "center", gap: "16px" }}>
        <Button
          key="back"
          onClick={() => {
            setVisible(false);
            form.resetFields();
          }}
        >
          Cancel
        </Button>
        <Button
          key="submit"
          type="primary"
          loading={loading}
          onClick={() => form.submit()}
        >
          Submit
        </Button>
      </div>}
    >
      <Flex justify="space-between" align="flex-start">
        <div className="model_top" style={{ width: "100%" }}>
          <div className="model_content">
            <Form
              form={form}
              name="createBankForm"
              layout="horizontal"
              labelCol={{ style: { width: "200px" } }}
              wrapperCol={{ style: { flex: 1 } }}
              onFinish={onFinish}
            >
              <Flex justify="space-between" align="flex-start">
                <div style={{ flex: 1 }}>
                 
                  {/* <Form.Item
                    name="allowanceCode"
                    label="Allowance Code"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Please enter a code." allowClear />
                  </Form.Item> */}
                   <Form.Item
                    name="allowanceName"
                    label="Allowance Name"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Please enter a name." allowClear />
                  </Form.Item>
               
                  {/* <Form.Item
                    name="allowanceType"
                    label="Allowance Type"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Allowance Type"
                      options={typeOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item> */}
                   <Form.Item
                     name="amount"
                     label="Amount"
                     rules={[{ required: true }]}
                   >
                     <InputNumber
                       style={{ width: "100%" }}
                       placeholder="Please enter an amount."
                       allowClear
                       min={0}
                       precision={2}
                       controls={false}
                       formatter={usdFormatter}
                       parser={usdParser}
                     />
                   </Form.Item>


                   <Form.Item
                    name="hours"
                    label="Hours"
                    rules={[{ required: true }]}
                  >
                    <Input placeholder="Please enter hours." allowClear />
                  </Form.Item>
                  <Form.Item
                    name="status"
                    label="Status"
                    rules={[{ required: true }]}
                  >
                    <Select
                      placeholder="Select Status"
                      options={stateOptions}
                      allowClear
                      showSearch
                      optionFilterProp="label"
                      filterOption={(input, option) =>
                        option.label.toLowerCase().includes(input.toLowerCase())
                      }
                    />
                  </Form.Item>
                     <Form.Item
                    name="remark"
                    label="Remark"
                  >
                    <Input placeholder="Please enter a remark." allowClear />
                  </Form.Item>
                </div>
              </Flex>
            </Form>
          </div>
        </div>
      </Flex>
    </Modal>
  );
});

export default AddModal;
